export const getInternalHref = (href, isFrodor) => isFrodor ? href : 'https://artists.spotify.com'.concat(href);
//# sourceMappingURL=getInternalHref.js.map